import { Flex, Pane, TableV2, DataBlock, Text, TextInput, Button, Popup } from '@leverege/ui-elements'
import { Item } from '@leverege/ui-elements/lib/esm/Popup'
import React, { useEffect, useState } from 'react'
import S from './Tables.css'
import useHeadCount from '../hooks/useHeadCount'
import { exportToCSV, exportToJSON } from '../util/exportFunctions'

function Tables( props ) {
  const { context, item } = props
  const { 
    columns,
    indirectLaborFields,
    directLaborFields,
    data : processedData,
    avgData : avgProcessedData
  } = useHeadCount( props )
  const [ headCountSumData, setHeadCountSumData ] = useState( [] )
  const [ currentPage, setCurrentPage ] = useState( 1 )
  const [ rowsPerPage, setRowsPerPage ] = useState( 100 )

  useEffect( () => {
    if ( processedData && processedData.length > 0 ) {
      setHeadCountSumData( processedData )
    }
  }, [ processedData ] )

  const handlePageChange = ( newPage ) => {
    setCurrentPage( newPage )
    context.clientProps.onSetPage( { page : newPage, perPage : rowsPerPage } )
  }

  const handleRowsPerPageChange = ( event ) => {
    const newRowsPerPage = parseInt( event.value, 10 )
    setRowsPerPage( newRowsPerPage )
    context.clientProps.onSetPage( { page : currentPage, perPage : newRowsPerPage } )
  }

  return (
    <Flex gap={14} variant="col" style={{ overflow : 'hidden', width : '100%', padding : '16px 16px 16px 16px' }}>
      <Flex variant="row" gap={12}>
        <Pane
          variant="dashboardCardCustom"
          layout="flex:col"
          style={{ width : '100%' }}>
          <Pane
            variant="dashboardCardCustomBigHeader"
            style={{ paddingLeft : 16 }}>
            <Flex variant="rowSpaceBetween">
              <Text variant="tableHeader"> Direct Labor Averages </Text>
            </Flex>
          </Pane>
          <div style={{ padding : '0px 16px 16px 16px' }}>
            <DataBlock
              variant="secondary"
              item={avgProcessedData.directLabor[0]}
              fields={directLaborFields}/>
          </div>
        </Pane>
        <Pane
          variant="dashboardCardCustom"
          layout="flex:col"
          style={{ width : '100%' }}>
          <Pane
            variant="dashboardCardCustomBigHeader"
            style={{ paddingLeft : 16 }}>
            <Flex variant="rowSpaceBetween">
              <Text variant="tableHeader"> Indirect Labor Averages </Text>
            </Flex>
          </Pane> 
          <div style={{ padding : '0px 16px 16px 16px' }}>
            <DataBlock
              variant="secondary"
              item={avgProcessedData.indirectLabor[0]}
              fields={indirectLaborFields}/>
          </div>
        </Pane>
      </Flex>
      <Pane
        variant="dashboardCardCustom"
        layout="flex:col"
        style={{ width : '100%' }}>
        <Pane
          variant="dashboardCardCustomBigHeader"
          style={{ paddingLeft : 16 }}>
          <Flex variant="rowS">
            <Text variant="tableHeader"> Occupancy events </Text>
            <Popup
              open
              closeOnEscape
              closeOnDocumentClick
              iconOn="fa-solid fa-ellipsis-vertical"
              iconOff="fa-solid fa-ellipsis-vertical">
              <Item onClick={() => exportToCSV( processedData, columns )}>
                export to CSV
              </Item>
              <Item onClick={() => exportToJSON( processedData )}>
                export to JSON
              </Item>
            </Popup>
          </Flex>
        </Pane>
        <div style={{ padding : '0px 16px 16px 16px' }}>
          {headCountSumData.length > 0 ? (
            <>
              <TableV2
                variant="delayTable"
                className={S.table}
                data={headCountSumData}
                columns={columns}/>
              <Flex 
                variant="row" 
                gap={8} 
                style={{ 
                  marginTop : 16,
                  justifyContent : 'center',
                  alignItems : 'center',
                  flexWrap : 'wrap' }}>
                <Text>Rows per pages</Text>
                <TextInput 
                  type="number"
                  value={rowsPerPage.toString()}
                  onChange={handleRowsPerPageChange}
                  size={5}
                  style={{ width : 50, height : 30 }}/>
                <Button 
                  variant="paginationPrev"
                  onClick={() => handlePageChange( currentPage - 1 )}
                  disabled={currentPage === 1}/>
                <Button 
                  variant="paginationNext"
                  onClick={() => handlePageChange( currentPage + 1 )}/>
              </Flex>
            </>
          ) : (
            <Text>{ item ? 'Loading data...' : 'No data present' }</Text>
          )}
        </div>
      </Pane>
    </Flex>
  )
}

export default Tables
